import React from "react";

export const Range: React.FC<{ value: RangeValue }> = ({ value }) => (
  <span>
    {value.min} - {value.max}
  </span>
);
